import { supabase } from './supabase';
import type { Milestone } from './queries/usePlayerPlan';

/**
 * Toggle a milestone's met state inside an existing development_plan.
 * Reads the current milestones array, flips the given index, writes
 * back. RLS enforces that the coach can only update their own plans.
 */
export async function toggleMilestoneMet(
  planId: string,
  index: number,
): Promise<{ ok: true; milestones: Milestone[] } | { ok: false; error: string }> {
  const { data, error: readErr } = await supabase
    .from('development_plans')
    .select('milestones')
    .eq('id', planId)
    .maybeSingle();
  if (readErr) return { ok: false, error: readErr.message };
  if (!data) return { ok: false, error: 'Plan not found.' };

  const current = (Array.isArray(data.milestones) ? data.milestones : []) as Milestone[];
  if (index < 0 || index >= current.length) return { ok: false, error: 'Milestone index out of range.' };

  const next = current.map((m, i) =>
    i === index ? { ...m, met_at: m.met_at ? null : new Date().toISOString() } : m,
  );

  const { error: writeErr } = await supabase
    .from('development_plans')
    .update({ milestones: next })
    .eq('id', planId);
  if (writeErr) return { ok: false, error: writeErr.message };
  return { ok: true, milestones: next };
}
